import api from "@/http";

function switchSpaceApi(params) {
  let url = "/v1/product/space/switch";
  return api.post(url, { data: params });
}

export { switchSpaceApi };
